import React, { useState } from "react";
import { Button, Input, Label, Modal, ModalBody, UncontrolledAlert } from "reactstrap";

const BulkSelectionModal = ({
    show,
    onCloseClick,
    onSelectCurrent,
    onSelectAll,
    isLoading,
    props
}: any) => {
    const [method, setMethod] = useState<"current" | "all">("current");

    return (
        <Modal backdrop="static" isOpen={show} toggle={onCloseClick} centered={true}>
            <ModalBody className="text-center p-3">
                <div className="mt-1">
                    {/* <i className="ri-checkbox-multiple-line display-5 text-primary"></i> */}
                    <Label className="fs-18 mb-2 mt-2">{props?.t?.("Select Records") || "Select Records"}</Label>

                    {/* Static Warning Alert */}
                    <UncontrolledAlert color="warning" className="alert-additional mb-4 text-start">
                        <div className="alert-body">
                            <div className="d-flex">
                                <div className="flex-shrink-0 me-3">
                                    <i className="ri-alert-line fs-16 align-middle"></i>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="alert-heading">
                                        {props?.t?.("Bulk Selection Warning") || "Bulk Selection Warning"}
                                    </h5>
                                    <p className="mb-0">
                                        {props?.t?.(
                                            "Bulk selection will allow you to perform actions on multiple records at once. Please review your selection carefully before confirming."
                                        ) ||
                                            "Bulk selection will allow you to perform actions on multiple records at once. Please review your selection carefully before confirming."}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="alert-content">
                            <p className="mb-0">
                                {props?.t?.(
                                    "This action cannot be undone. Proceed with caution."
                                ) || "This action cannot be undone. Proceed with caution."}
                            </p>
                        </div>
                    </UncontrolledAlert>

                    {/* Current Page Option */}
                    <div className="form-check form-radio-primary mb-3">
                        <Input
                            className="form-check-input"
                            type="radio"
                            id="currentPageRadio"
                            name="bulkSelection"
                            onChange={() => setMethod("current")}
                            checked={method === "current"}
                        />
                        <Label className="form-check-label" for="currentPageRadio">
                            {props?.t?.("Select Current Page") || "Select Current Page"}
                        </Label>
                        <div className="form-text text-muted">
                            {props?.t?.("Only records visible on this page will be selected.") ||
                                "Only records visible on this page will be selected."}
                        </div>
                    </div>

                    {/* All Entries Option */}
                    <div className="form-check form-radio-primary mb-3">
                        <Input
                            className="form-check-input"
                            type="radio"
                            id="allEntriesRadio"
                            name="bulkSelection"
                            onChange={() => setMethod("all")}
                            checked={method === "all"}
                        />
                        <Label className="form-check-label" for="allEntriesRadio">
                            {props?.t?.("Select All Entries") || "Select All Entries"}
                        </Label>
                        <div className="form-text text-muted">
                            {props?.t?.("All matching records from the database will be selected.") ||
                                "All matching records from the database will be selected."}
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="hstack gap-2 justify-content-center">
                        <Button
                            color="primary"
                            disabled={isLoading}
                            onClick={() => {
                                if (method === "current") {
                                    onSelectCurrent();
                                } else {
                                    onSelectAll();
                                }
                                onCloseClick();
                            }}
                        >
                            {props?.t?.("Confirm") || "Confirm"}
                        </Button>

                        <Button color="secondary" onClick={onCloseClick} outline>
                            {props?.t?.("Cancel") || "Cancel"}
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default BulkSelectionModal;
